import reducer from './reducer';

export const { openBasketModal, closeBasketModal } = reducer.actions;
